import React, { useEffect, useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Image } from 'expo-image';
import { useTheme } from '../context/ThemeContext';
import { fetchStudentProfilePictureUrl } from '../utils/studentProfilePhoto';

const AVATAR_SIZE = 40;

export default function StudentAvatar({
  studentId,
  studentName,
  profilePictureUrl,
  size = AVATAR_SIZE,
  style,
  webDataSet = {},
}) {
  const theme = useTheme();
  const [resolvedPhotoUrl, setResolvedPhotoUrl] = useState(
    profilePictureUrl?.trim?.() || null
  );

  useEffect(() => {
    setResolvedPhotoUrl(profilePictureUrl?.trim?.() || null);
  }, [profilePictureUrl]);

  useEffect(() => {
    if (profilePictureUrl?.trim?.()) return;
    if (studentId == null) return;
    let cancelled = false;
    void fetchStudentProfilePictureUrl(studentId).then((url) => {
      if (!cancelled) setResolvedPhotoUrl(url);
    });
    return () => {
      cancelled = true;
    };
  }, [studentId, profilePictureUrl]);

  const initialLetter = (
    (studentName && String(studentName).trim().charAt(0)) ||
    'S'
  ).toUpperCase();

  const borderRadius = size / 2;
  const styles = getStyles(theme, size, borderRadius);

  return (
    <View
      style={[styles.wrap, style]}
      {...(webDataSet && Object.keys(webDataSet).length
        ? { dataSet: webDataSet }
        : {})}
    >
      {resolvedPhotoUrl ? (
        <Image source={{ uri: resolvedPhotoUrl }} style={styles.image} contentFit="cover" />
      ) : (
        <View style={styles.fallback}>
          <Text style={styles.initial}>{initialLetter}</Text>
        </View>
      )}
    </View>
  );
}

const getStyles = (theme, size, borderRadius) =>
  StyleSheet.create({
    wrap: {
      width: size,
      height: size,
      borderRadius,
      overflow: 'hidden',
      flexShrink: 0,
      backgroundColor: 'transparent',
    },
    image: {
      width: size,
      height: size,
      borderRadius,
      borderWidth: 2,
      borderColor: theme.colors.heading || '#d4af37',
    },
    fallback: {
      width: size,
      height: size,
      borderRadius,
      backgroundColor: theme.colors.primary || '#d4af37',
      justifyContent: 'center',
      alignItems: 'center',
      borderWidth: 2,
      borderColor: theme.colors.heading || '#d4af37',
    },
    initial: {
      color: '#FFFFFF',
      fontSize: size >= 40 ? 18 : 14,
      fontWeight: 'bold',
      backgroundColor: 'transparent',
    },
  });
